import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useTheme } from '../../context/ThemeContext';

const MobileBottomNav = ({ onAddClick, onMenuClick }) => {
    const { isDark } = useTheme();
    const location = useLocation();

    const isActive = (path) => {
        return location.pathname === path || (path !== '/dashboard' && location.pathname.startsWith(path));
    };

    const NavItem = ({ to, icon, label, onClick }) => {
        const active = to ? isActive(to) : false;

        const content = (
            <div className={`flex flex-col items-center justify-center w-full h-full space-y-1 ${active
                    ? (isDark ? 'text-cyan' : 'text-primary')
                    : (isDark ? 'text-light/50 hover:text-light' : 'text-darkTeal/50 hover:text-darkTeal')
                }`}>
                <span className={`material-symbols-outlined text-2xl ${active ? 'fill-current' : ''}`} style={active ? { fontVariationSettings: "'FILL' 1" } : {}}>
                    {icon}
                </span>
                <span className="text-[10px] font-medium">{label}</span>
            </div>
        );

        if (onClick) {
            return (
                <button onClick={onClick} className="flex-1 h-full">
                    {content}
                </button>
            );
        }

        return (
            <NavLink to={to} className="flex-1 h-full">
                {content}
            </NavLink>
        );
    };

    return (
        <div className={`fixed bottom-0 left-0 right-0 h-16 bg-white dark:bg-navy border-t border-gray-200 dark:border-white/10 flex items-center justify-around z-50 lg:hidden safe-area-pb`}>
            <NavItem to="/dashboard" icon="dashboard" label="Home" />
            <NavItem to="/leads" icon="leaderboard" label="Leads" />

            {/* Quick Add FAB */}
            <div className="relative -top-5">
                <button
                    onClick={onAddClick}
                    className={`w-14 h-14 rounded-full flex items-center justify-center shadow-lg transform transition-transform active:scale-95 ${isDark
                            ? 'bg-cyan text-navy shadow-[0_0_15px_rgba(8,217,214,0.4)]'
                            : 'bg-primary text-white shadow-[0_4px_10px_rgba(255,46,99,0.3)]'
                        }`}
                >
                    <span className="material-symbols-outlined text-3xl">add</span>
                </button>
            </div>

            <NavItem to="/channels" icon="hub" label="Channels" />
            <NavItem icon="menu" label="More" onClick={onMenuClick} />
        </div>
    );
};

export default MobileBottomNav;
